import { Dictionary } from "flow/api/types";
import environment from "flow/configuration/environment";

let sortOrder: Dictionary<number> = {};
let hiddenContainers: string[] = [];

function getKey() {
    const product = environment.get(environment.keys.productId);
    //const payload = environment.get(environment.keys.productPayload);
    return "sortorder_" + product;
}

export function save(newSortOrder: Dictionary<number>, hideIds: string[]) {
    sortOrder = newSortOrder;
    hiddenContainers = hideIds;

    const obj = {
        sortOrder,
        hiddenContainers
    };

    console.log("save", obj);

    localStorage.setItem(getKey(), JSON.stringify(obj));
}

function loadDefaults() {
    sortOrder = {};
    hiddenContainers = [];
}

export function load() {
    try {
        const key = getKey();
        const storedData = localStorage.getItem(key);

        if (!storedData) {
            loadDefaults();
            return;
        }

        const obj = JSON.parse(storedData);

        console.log("load", obj);

        sortOrder = obj.sortOrder || {};
        hiddenContainers = obj.hiddenContainers || [];
    } catch (e) {
        //api.core.logger.error("Error parsing home screen settings from local storage", e);
        loadDefaults();
    }
}

export function isHidden(id: string) {
    return hiddenContainers.includes(id);
}

export function getSortOrder(id: string, defaultOrder: number) {
    const override = sortOrder[id];

    console.log({ id, override, defaultOrder });

    return sortOrder[id] ?? defaultOrder;
}
